import Vue from 'vue'
import { DateTime } from 'luxon'

Vue.filter('capitalize', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('tagAudience', function(value) {
  if (!value) return ''
  if (value == 'audience') {
    value = value.toString()
    return value.replace('audience', 'Target Audience')
  }
  return value
})

Vue.filter('truncate', function(text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
})

Vue.filter('removeCaracterSpecial', function(text) {
  if (!text) return ''
  return text.replace('_', ' ')
})

Vue.filter('formatDate', function(date) {
  if (!date) return ''
  const dt = DateTime.fromISO(date)
  return dt.toLocaleString(DateTime.DATE_FULL)
})

Vue.filter('formatHour', function(date) {
  if (!date) return ''
  const dt = DateTime.fromISO(date)
  return dt.toLocaleString(DateTime.TIME_24_SIMPLE)
})

Vue.filter('nameIconConvert', function(value) {
  if (!value) return ''
  const typeList = {
    sendNow: 'Now',
    schedule: 'Schedule',
    allAudience: 'All Audience',
    newSms: 'New',
    smsTemplate: 'Template',
    segments: 'Segments',
  }
  return typeList[value] || null
})

Vue.filter('numberWithCommas', function(value) {
  if (!value) return value
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})
